import React, { useEffect, useState } from "react";
import { Routes, Route } from "react-router-dom";
import LoginPage from "./Pages/LoginPage"; // Make sure this import path is correct
import Dashboard from "./Pages/Dashboard"; // Make sure this import path is correct
// import 'dotenv/config';
import './App.css';
import { AuthProvider } from './contextApi/useAuth';


function App() {
 // State to track login status

  return (
    <AuthProvider>
    <div className="w-screen h-screen flex flex-col " >
      <Routes>
        {/* Login route */}
        <Route path="/" element={<LoginPage  />} />
        
        {/* PrivateRoute for dashboard, protecting it with isLoggedIn */}
        <Route
          path="/dashboard"
          element={
            <Dashboard /> 
          }
        />
      </Routes>
    </div>
  </AuthProvider>
  );
}

export default App;
